<div class="animate-pulse mb-2 h-[1.125rem] flex items-center">
  <div class="animate-pulse bg-skeleton h-[0.8125rem] w-1/3 rounded-md"></div>
</div>

<div class="animate-pulse h-[1.3125rem] flex items-center">
  <div class="animate-pulse bg-skeleton h-[0.9375rem] w-1/2 rounded-md"></div>
</div>
